import { IClassname } from '@/lib/shared/model/classname';

export const Tennis = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5557 19.3607C15.9907 19.6489 13.458 20.1751 10.9905 20.9325C11.7437 18.4609 12.2614 15.9236 12.5368 13.3545"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9776 20.9326L6.91382 24.9964"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.2456 16.4089C23.5013 20.1532 17.8401 20.5622 14.5942 17.3163C11.3483 14.0704 11.7572 8.37085 15.5015 4.6649C19.2458 0.958937 24.9453 0.511666 28.1529 3.75757C31.3605 7.00348 30.9899 12.6647 27.2456 16.4089Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6963 2.44141L29.4691 13.2142"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5015 4.66504L27.2455 16.4091"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2778 7.85986L24.0507 18.6327"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.677 1.81494L12.6646 13.8785"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1529 3.75781L14.5942 17.3165"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.0954 7.2334L18.083 19.2714"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.79907 5.47018C2.79907 5.88973 2.88171 6.30517 3.04226 6.69278C3.20281 7.08039 3.43814 7.43258 3.7348 7.72924C4.03147 8.0259 4.38366 8.26123 4.77127 8.42178C5.15888 8.58234 5.57432 8.66497 5.99386 8.66497C6.41341 8.66497 6.82885 8.58234 7.21646 8.42178C7.60407 8.26123 7.95626 8.0259 8.25292 7.72924C8.54959 7.43258 8.78491 7.08039 8.94547 6.69278C9.10602 6.30517 9.18866 5.88973 9.18866 5.47018C9.18866 4.62287 8.85206 3.81026 8.25292 3.21112C7.65378 2.61198 6.84118 2.27539 5.99386 2.27539C5.14655 2.27539 4.33394 2.61198 3.7348 3.21112C3.13567 3.81026 2.79907 4.62287 2.79907 5.47018Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.8469 30.0569C3.7281 30.1767 3.58676 30.2717 3.43103 30.3366C3.27531 30.4015 3.10827 30.4349 2.93957 30.4349C2.77087 30.4349 2.60384 30.4015 2.44812 30.3366C2.29239 30.2717 2.15105 30.1767 2.03225 30.0569C1.79424 29.8175 1.66064 29.4936 1.66064 29.156C1.66064 28.8184 1.79424 28.4945 2.03225 28.255L5.64876 24.6385C5.70581 24.5771 5.77508 24.5284 5.85211 24.4954C5.92914 24.4623 6.01223 24.4458 6.09603 24.4468C6.18175 24.4456 6.26681 24.462 6.34595 24.4949C6.42508 24.5279 6.4966 24.5768 6.55608 24.6385L7.45062 25.5331C7.51051 25.5925 7.55804 25.6631 7.59048 25.741C7.62292 25.8189 7.63962 25.9024 7.63962 25.9867C7.63962 26.0711 7.62292 26.1546 7.59048 26.2325C7.55804 26.3103 7.51051 26.381 7.45062 26.4404L3.8469 30.0569Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
